import type { JSX, FC } from 'react';

import type { RegisterDialogData } from '../../../../types/helsenorge.helseregistre.internalapi.entities.entities';
import type { HNHelseregistreJS } from '../../../../types/Resources';

import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';

import { shortDateNumbers } from '@helsenorge/core-utils/date-fns-utils';

import { getDialogTypeBeskrivelse } from '../utils';

interface Props {
  dialogTypes: RegisterDialogData[] | null;
  resources: HNHelseregistreJS;
}

export const BestillingerStatusILightBox: FC<Props> = ({ dialogTypes, resources }): JSX.Element | null => {
  const blokkerteDialoger =
    dialogTypes &&
    dialogTypes.reduce((blokkerte: JSX.Element[], dialog: RegisterDialogData) => {
      if (dialog.blokkert) {
        blokkerte.push(
          <li key={`${dialog.dialogType}-${dialog.forespurtTid}`}>
            <strong>{getDialogTypeBeskrivelse(dialog.dialogType, resources)}</strong>{' '}
            {dialog.forespurtTid ? ` (${shortDateNumbers(new Date(dialog.forespurtTid))})` : ''}
          </li>
        );
      }
      return blokkerte;
    }, []);

  return blokkerteDialoger && blokkerteDialoger.length > 0 ? (
    <NotificationPanel label={resources.bestillingPaaVentMessage}>{[<ul key={0}>{blokkerteDialoger}</ul>]}</NotificationPanel>
  ) : null;
};
